//Opening component

import React, { useEffect } from "react";
import { Link, animateScroll as scroll } from "react-scroll";

import TitleImage from "../../assets/Title.png";
import ZiplyneLogo from "../../assets/ZiplyneLogo.png";
import JohnsHopkins from "../../assets/JohnsHopkins.png";
import DIAMOND from "../../assets/DIAMOND.png";

import AOS from "aos";
import "aos/dist/aos.css";

const Title = (props) => {
  useEffect(() => {
    AOS.init({
      duration: 2500,
    });
  }, []);

  return (
    <div id="Title">
      <div data-aos={"fade-right"} className="Title__nav"></div>
      <div data-aos={"fade-right"} className="Title__diamonds">
        <div className="Title__link">
          <img src={DIAMOND} className="Title__diamond" alt="" />{" "}
          <Link
            activeClass="active"
            to="WhatIsZiplyne"
            className="Title__textNav"
            spy={true}
            smooth={true}
            duration={1000}
          >
            Ziplyne & DAP
          </Link>
        </div>
        <div className="Title__link">
          <img src={DIAMOND} className="Title__diamond" alt="" />
          <Link
            activeClass="active"
            className="Title__textNav"
            to="Benefits"
            spy={true}
            smooth={true}
            duration={1000}
          >
            Benefits of Ziplyne
          </Link>
        </div>
        <div className="Title__link">
          <img src={DIAMOND} className="Title__diamond" alt="" />
          <Link
            activeClass="active"
            className="Title__textNav"
            to="JHUTeams"
            spy={true}
            smooth={true}
            duration={1000}
          >
            Departments Using Ziplyne
          </Link>
        </div>
        <div className="Title__link">
          <img src={DIAMOND} className="Title__diamond" alt="" />
          <Link
            activeClass="active"
            className="Title__textNav"
            to="Zipster"
            spy={true}
            smooth={true}
            duration={1000}
          >
            Become a Zipster
          </Link>
        </div>
        <div className="Title__link">
          <img src={DIAMOND} className="Title__diamond" alt="" />
          <Link
            activeClass="active"
            className="Title__textNav"
            to="TrainingDates"
            spy={true}
            smooth={true}
            duration={1000}
          >
            Download Ziplyne
          </Link>
        </div>
        <div className="Title__link">
          <img src={DIAMOND} className="Title__diamond" alt="" />
          <Link
            activeClass="active"
            className="Title__textNav"
            to="Workflow"
            spy={true}
            smooth={true}
            duration={1000}
          >
            Taking your Zips live
          </Link>
        </div>
        <div className="Title__link">
          <img src={DIAMOND} className="Title__diamond" alt="" />
          <Link
            activeClass="active"
            className="Title__textNav"
            to="EmbedForm"
            spy={true}
            smooth={true}
            duration={1000}
          >
            Embed Script Generator
          </Link>
        </div>
        <div className="Title__link">
          <img src={DIAMOND} className="Title__diamond" alt="" />
          <a 
            className="Title__textNav"
            href="http://help.ziplyne.com/en/articles/5938374-v6-release-notes"
            target="_blank"
          >
            Release Notes
          </a>
        </div>
        <div className="Title__link">
          <img src={DIAMOND} className="Title__diamond" alt="" />
          <Link
            activeClass="active"
            className="Title__textNav"
            to="FAQs"
            spy={true}
            smooth={true}
            duration={1000}
          >
            FAQs
          </Link>
        </div>
      </div>
      <h2 data-aos={"fade-right"} className="Title__text">
        Johns Hopkins and Ziplyne: Digital Adoption for the World of Today...
        and Tomorrow!
      </h2>
      <img className="Title__background" src={TitleImage} alt="" />
      <img className="Title__ziplyneLogo" src={ZiplyneLogo} alt="" />
      <img className="Title__JohnsHopkinsLogo" src={JohnsHopkins} alt="" />
    </div>
  );
};

export default Title;
